import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted, ref } from 'vue';
  import keycloak, { logoutFromApp } from '@/plugins/keycloak';
  import router from '@/router';
  import { useInteractionModeStore } from '@/store/interactionModeStore';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutButton',
  setup(__props) {

  const now = ref(Date.now());
  let timer: number | undefined;
  const interactionModeStore = useInteractionModeStore();

  const countdownText = computed(() => {
    const expiration = keycloak?.getSessionExpiration();
    if (!expiration) return 'N/A';

    const diff = expiration.getTime() - now.value;
    if (diff <= 0) return 'Expired';

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const pad = (n: number) => (n < 10 ? '0' : '') + n;

    return `${pad(minutes)}:${pad(seconds)}`;
  });

  async function renewToken() {
    try {
      // Passing -1 or a low value forces a refresh if the refresh token is valid
      await keycloak.updateToken(-1);
      now.value = Date.now(); // Force UI update
    } catch (error) {
      console.error('Failed to renew token', error);
    }
  }

  function logout() {
    interactionModeStore.leaveEditMode();
    logoutFromApp();
  }

  function changeSubject() {
    localStorage.removeItem('selectedSubjectIdentifier');
    router.push('/landing');
  }

  function isSessionExpired() {
    const expiration = keycloak?.getSessionExpiration();
    if (!expiration) return true;

    const diff = expiration.getTime() - now.value;
    return diff <= 0;
  }

  onMounted(() => {
    timer = window.setInterval(() => {
      now.value = Date.now();
      if (isSessionExpired()) {
        logout();
      }
    }, 1000);
  });

  onUnmounted(() => {
    if (timer) clearInterval(timer);
  });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      variant: "text",
      small: "",
      class: "logoutButton",
      onClick: changeSubject
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('profile.changeSubject')) + "   ", 1),
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-cached", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_tooltip, { interactive: "" }, {
      activator: _withCtx(({ props: activatorProps }) => [
        _createVNode(_component_v_btn, _mergeProps({
          variant: "text",
          small: "",
          class: "logoutButton"
        }, activatorProps, { onClick: logout }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('profile.logout')) + "   ", 1),
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-location-exit", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('profile.sessionExpiredAt')) + " " + _toDisplayString(countdownText.value) + " ", 1),
          _createElementVNode("button", {
            class: "renew-btn",
            onClick: renewToken
          }, [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-refresh", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})